import { injectable } from 'inversify';
import { ILoginFormExtensionProps, ILoginFormExtensions } from './ILoginFormExtensions';

@injectable()
export class NullLoginFormExtension implements ILoginFormExtensions {
    getExtensions(): ILoginFormExtensionProps[] {
        return [];
    }
}
